import React from 'react';
import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@hub/accordion';
import { Text } from '@hub/text';
import { Link } from '@hub/link';
import { Stack } from '@hub/stack';
import analyticsUtils from '../../../helpers/analytics-utils';
import trackClickEvent from '../../../helpers/analytics-utils/track-event';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PaneAccordion = _ref => {
  let {
    itemCnt,
    itemTitle,
    items
  } = _ref;
  return /*#__PURE__*/_jsxs(AccordionItem, {
    sx: {
      border: 'none',
      paddingTop: 'spacing-sm',
      paddingBottom: 'spacing-md',
      width: 'size-full'
    },
    "data-id": "pane-accordion_index_PaneAccordion_AccordionItem",
    children: [/*#__PURE__*/_jsxs(AccordionButton, {
      sx: {
        padding: 0,
        margin: 0
      },
      "data-id": "pane-accordion_index_PaneAccordion_AccordionItem_AccordionButton",
      children: [/*#__PURE__*/_jsx(Text, {
        tone: "strong",
        fontSize: "font-lg",
        align: "left",
        sx: {
          flex: 1
        },
        "data-id": "pane-accordion_index_PaneAccordion_AccordionButton_Text",
        children: itemTitle
      }), /*#__PURE__*/_jsx(AccordionIcon, {
        "data-id": "pane-accordion_index_PaneAccordion_AccordionButton_AccordionIcon"
      })]
    }), /*#__PURE__*/_jsx(AccordionPanel, {
      "data-id": "pane-accordion_index_PaneAccordion_AccordionItem_AccordionPanel",
      children: /*#__PURE__*/_jsx(Stack, {
        gap: "spacing-lg",
        sx: {
          paddingX: 'spacing-md',
          paddingTop: 'spacing-lg',
          fontSize: 'font-sm',
          lineHeight: '16px'
        },
        "data-id": "pane-accordion_index_PaneAccordion_AccordionPanel_Stack",
        children: items && items.map((item, i) => {
          if (!item || !('url' in item)) {
            return null;
          }

          return /*#__PURE__*/_jsx(Link, {
            to: item.url,
            href: item.url,
            onClick: () => {
              var _item$onClick;

              trackClickEvent(analyticsUtils.categories.UNIVERSAL_HEADER, analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK, "L1-".concat(itemCnt, "-").concat(i, " ").concat(itemTitle, " - ").concat(item.label));
              (_item$onClick = item.onClick) === null || _item$onClick === void 0 ? void 0 : _item$onClick.call(item);
            },
            "data-id": "pane-accordion_index_PaneAccordion_Link",
            children: item.label
          }, i);
        })
      })
    })]
  });
};